import React from "react";
import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SunIconOutline } from "@icons";
import { useThemeMode } from "hooks/useThemeMode";
import { ThemeModeEnum } from "context/ThemeModeContext";

const MoonIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 10.5A6.5 6.5 0 1 1 5.5 2a5 5 0 0 0 8.5 8.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: 6,
  color: theme.semantic.cTextStrong,
  "&:hover": {
    backgroundColor: theme.semantic.cNavHoverBg,
  },
}));

const ThemeToggle = () => {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === ThemeModeEnum.Dark;

  return (
    <StyledIconButton
      onClick={toggleMode}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-test-id="theme-toggle"
    >
      {isDark ? <SunIconOutline fill="currentColor" /> : <MoonIcon />}
    </StyledIconButton>
  );
};

export default ThemeToggle;
